import React from 'react';
import '../utils/axiosConfig'; // runs the 401/403 logout logic globally
import '../Style/Modal.css';
import "../Style/Responsive.css";
// Make sure this path matches your project structure

const Modal = ({ message, onClose }) => {
  if (!message) return null; // Do not render if there's no message

  return (
    <div className="modal">
      <div className="modal-container">
        <div className="modal-header">
          <h2>Error</h2>
          <button className="modal-close" onClick={onClose}>
            close
          </button>
        </div>
        <div className="modal-message">
          <p>{message}</p>
        </div>
      </div>
    </div>
  );
};

export default Modal;
